(function () {
  function calcPct(sale, compare) {
    if (!compare || !sale || compare <= sale) return null;
    return Math.round((1 - sale / compare) * 100);
  }

  function parseMoney(str) {
    if (!str) return null;
    var n = parseFloat(str.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  function updateLabels() {
    // Find every element whose class contains 'sale' inside a boost-sd product context
    var cards = document.querySelectorAll('[class*="boost-sd__product-item"], [class*="boost-sd__product-card"]');

    cards.forEach(function (card) {
      // Find the sale label
      var label = card.querySelector('[class*="sale"]');
      if (!label) return;
      // Skip if already showing a percentage
      if (/\d+%/.test(label.textContent)) return;

      var pct = null;

      // 1. Try data attributes (prices in cents)
      var dp  = card.dataset.price || card.dataset.productPrice;
      var dcp = card.dataset.compareAtPrice || card.dataset.productCompareAtPrice
             || card.dataset.comparePrice;
      if (dp && dcp) {
        pct = calcPct(parseFloat(dp), parseFloat(dcp));
      }

      // 2. Fall back to rendered price elements
      if (!pct) {
        // Boost renders compare price in an element with 'compare' or 'was' in class
        var compareEl = card.querySelector('[class*="compare"], [class*="was"], s, del');
        // Sale price is the bold/highlighted price — first .money or price span
        var saleEl = card.querySelector('[class*="sale-price"], [class*="current-price"], [class*="price--sale"]');

        if (!saleEl) {
          // grab all price spans and take the lowest value as sale, highest as compare
          var allPrices = Array.from(card.querySelectorAll('[class*="price"] [class*="money"], [class*="price"]'))
            .map(function(el) { return parseMoney(el.textContent); })
            .filter(Boolean);
          if (allPrices.length >= 2) {
            var sorted = allPrices.slice().sort(function(a,b){return a-b;});
            pct = calcPct(sorted[0], sorted[sorted.length - 1]);
          }
        } else if (compareEl) {
          pct = calcPct(
            parseMoney(saleEl.textContent),
            parseMoney(compareEl.textContent)
          );
        }
      }

      if (pct && pct > 0) {
        label.textContent = '-' + pct + '%';
      }
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLabels);
  } else {
    updateLabels();
  }

  // Re-run whenever Boost injects new product cards (filter/sort changes)
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          (n.className && typeof n.className === 'string' && n.className.indexOf('boost-sd') > -1) ||
          n.querySelector && n.querySelector('[class*="boost-sd__product"]')
        );
      });
    });
    if (relevant) setTimeout(updateLabels, 150);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
